var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.031 6.688l-6.86 6.86a4.219 4.219 0 01-5.967-5.966L7.84 1.948a2.813 2.813 0 113.977 3.977l-5.634 5.638a1.406 1.406 0 01-1.989-1.989l5.635-5.636"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0ibTE1LjAzMSA2LjY4OC02Ljg2IDYuODZhNC4yMTkgNC4yMTkgMCAwIDEtNS45NjctNS45NjZMNy44NCAxLjk0OGEyLjgxMyAyLjgxMyAwIDEgMSAzLjk3NyAzLjk3N2wtNS42MzQgNS42MzhhMS40MDYgMS40MDYgMCAwIDEtMS45ODktMS45ODlsNS42MzUtNS42MzYiLz48L3N2Zz4=";
export { SvgIconAttach as ReactComponent };